import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { ApiResponseBody, userApiClient } from '@/setup/api'

export type IGetFaqQueryData = ApiResponseBody<'get', '/web/faq'>['data']

export type FaqSection = IGetFaqQueryData['sections'][number]

export type FaqItem = FaqSection['items'][number]

export const getFaqQueryOptions = (locale: string) =>
    userApiClient.queryOptions('get', '/web/faq', {
        headers: { 'accept-language': locale },
    })

export function useGetFaqQuery() {
    const locale = useLocale()

    return useQuery(getFaqQueryOptions(locale))
}
